import React from 'react';

import { TPipelineStepTypeIcon } from '@/console/features/pipelines/hooks/use-pipeline-step-type/use-pipeline-step-type.types';
import { CircleIcon } from '@/shared/assets/icons/circle-icon';
import { CodeIcon } from '@/shared/assets/icons/code-icon';
import { ConversionJobIcon } from '@/shared/assets/icons/conversion-job-icon';
import { DeploymentIcon } from '@/shared/assets/icons/deployment-icon';
import { DeviceSnapshotIcon } from '@/shared/assets/icons/device-snapshot-icon';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { FTPBackUpIcon } from '@/shared/assets/icons/ftp-backup-icon';
import { LicenseIcon } from '@/shared/assets/icons/license-icon';
import { ProjectBackupIcon } from '@/shared/assets/icons/project-backup-icon';
import { ProjectsIcon } from '@/shared/assets/icons/projects-icon';
import { RefreshIcon } from '@/shared/assets/icons/refresh-icon';
import { ResetPasswordIcon } from '@/shared/assets/icons/reset-password-icon';
import { RestoreFtpIcon } from '@/shared/assets/icons/restore-ftp-icon';
import { RestoreSmbIcon } from '@/shared/assets/icons/restore-smb-icon';
import { ShowIcon } from '@/shared/assets/icons/show-icon';
import { SmbBackupIcon } from '@/shared/assets/icons/smb-backup-icon';
import { UpdateIcon } from '@/shared/assets/icons/update-icon';
import { WriteVariablesIcon } from '@/shared/assets/icons/write-variables-icon';
import { FeatureEnum } from '@/shared/types/types.generated';

export const pipelineStepTypeIcon: Partial<TPipelineStepTypeIcon> = {
  [FeatureEnum.ProjectBackup]: <ProjectBackupIcon />,
  [FeatureEnum.Deployment]: <DeploymentIcon />,
  [FeatureEnum.DevicePasswordUpdate]: <ResetPasswordIcon />,
  [FeatureEnum.ProjectLibraryUpgrade]: <UpdateIcon />,
  [FeatureEnum.DeviceFirmwareUpdate]: <DevicesIcon />,
  [FeatureEnum.ReadVariableListFromDevice]: <CodeIcon />,
  [FeatureEnum.DeviceSnapshot]: <DeviceSnapshotIcon />,
  [FeatureEnum.DeviceSnapshotRestore]: <RefreshIcon />,
  [FeatureEnum.Ideaas]: <CircleIcon />,
  [FeatureEnum.LicenseValidate]: <LicenseIcon />,
  [FeatureEnum.ProjectConvert]: <ConversionJobIcon />,
  [FeatureEnum.ProjectMerge]: <ProjectsIcon />,
  [FeatureEnum.ProjectView]: <ShowIcon />,
  [FeatureEnum.WriteVariableListToDevice]: <WriteVariablesIcon />,
  [FeatureEnum.FtpBackup]: <FTPBackUpIcon />,
  [FeatureEnum.SmbBackup]: <SmbBackupIcon />,
  [FeatureEnum.FtpRestore]: <RestoreFtpIcon />,
  [FeatureEnum.SmbRestore]: <RestoreSmbIcon />,
};
